export function getNutritionPlanLibraryCardLayout(screenSize) {
  const isSmallScreen = screenSize === "small";
  const columnCount = isSmallScreen ? 1 : 2;
  const gap = isSmallScreen ? 8 : 12;

  return {
    columnCount,
    gap,
    cardWidth: `calc((100% - ${(columnCount - 1) * gap}px) / ${columnCount})`,
  };
}

export function resolvePendingNutritionPlanRowUiState({
  isOffline = false,
  isActionInFlight = false,
} = {}) {
  const isDisabled = isOffline || isActionInFlight;

  return {
    isDisabled,
    showMenuTrigger: !isDisabled,
    openMenuOnPress: !isDisabled,
    shouldFadeCard: isOffline,
  };
}
